module.exports = __webpack_public_path__ + "static/media/favicon.91d65ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/favicon.png
// module id = 923
// module chunks = 0